<script>
export default {
    name : "DimensionMixin",
    methods: {
        getWidth () {
            return this.getStyleProperty("width", { defaultValue : 0 , parse : "float" });
        },
        getHeight () {
            return this.getStyleProperty("height", { defaultValue : 0 , parse : "float" });
        },
        setWidth (data) {

            let params = {
                styleProp : "width",
                value : data.value,
                valuePostFix : "px"
            }

            this.applyStyle(params);
            if (this.analogDimensions) {
                this.applyStyle({styleProp : "height", value : 'auto'})
            }

            window.eventBus.$emit("recompute-layout")

            if (this.inTopbar) {
                this.syncTopbarLogoDimension('width', data);
            }
        },
        setHeight (data) {

            let params = {
                styleProp : "height",
                value : data.value,
                valuePostFix : "px"
            }

            this.applyStyle(params);

            if (this.analogDimensions) {
                this.applyStyle({styleProp : "width", value : 'auto'})
            }
            window.eventBus.$emit("recompute-layout")

            if (this.inTopbar) {
                this.syncTopbarLogoDimension('height', data);
            }
        },
        syncTopbarLogoDimension (dimension, data) {
            const myTopbarId = this.hasContext('school-topbar')[0]?.id || this.hasContext('page-topbar')[0]?.id;
            const myTopbarState = this.findNodeState(myTopbarId);
            const otherTopbarState = this.findNodeState(myTopbarState.siblingTopbarId);
            const otherTopbarLogo = otherTopbarState.nestedElementIds.map(elementId => this.findNodeState(elementId)).find(elementState => elementState.elementType === 'image');

            const otherDimension = dimension === 'width' ? 'height' : 'width';

            let params = {
                styleProp : dimension,
                value : data.value,
                valuePostFix : "px"
            }

            otherTopbarLogo.applyStyle(params);
            otherTopbarLogo.applyStyle({styleProp : otherDimension, value : 'auto'});
        }

    }
}
</script>
